<template>
  <ll-tooltip
    :open="hoverTip ? undefined : false"
    :tip="hoverTip"
    :show-container="false"
  >
    <a-progress
      v-bind="attrs"
      :success="success"
      :steps="steps"
      :stroke-color="getStrokeColor"
      :class="[bem.b(), bem.is(textPosition)]"
    >
      <template v-if="format || $slots.format" #format="percent">
        <slot name="format" :percent="percent">
          <ll-html :value="value(percent)" />
        </slot>
      </template>
    </a-progress>
  </ll-tooltip>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'
import { progressBarProps } from './progress-bar'

defineOptions({ name: 'LlProgressBar' })

const props = defineProps(progressBarProps)

const bem = createNamespace('progress-bar')

const attrs = useAttrs()

const value = computed(() => {
  const successPercent = props.success?.percent || 0
  return (percent: number) => {
    return props.format && typeof props.format === 'function'
      ? props.format(percent, successPercent)
      : percent
  }
})

const getStrokeColor = computed(() => {
  if (typeof props.strokeColor === 'object') {
    if (Object.keys(props.strokeColor).length > 0) {
      if (props.steps && props.steps > 0) {
        return props.strokeColor[Object.keys(props.strokeColor)[0]]
      } else {
        return props.strokeColor
      }
    } else {
      return undefined
    }
  } else {
    return props.strokeColor
  }

  // if (props.steps && props.steps > 0) {
  //   if (typeof props.strokeColor === 'object') {
  //     if (Object.keys(props.strokeColor).length > 0) {
  //       return props.strokeColor[Object.keys(props.strokeColor)[0]]
  //     } else {
  //       return undefined
  //     }
  //   } else {
  //     return props.strokeColor
  //   }
  // } else {
  //   return props.strokeColor
  // }
})
</script>
